import { SequenceManagerAction } from "./SequenceManagerAction";

const MobilyOTPLineAction = {
    MOBILY_OTP_MAKE_SELECTION : "MOBILY_OTP_MAKE_SELECTION",
}

const numberSelected = (selection: any, offerContainerId: any) => {
  return function (dispatch: any) {
    dispatch({ type: MobilyOTPLineAction.MOBILY_OTP_MAKE_SELECTION, payload: { selection: selection, offerContainerId: offerContainerId } });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['MobilyOTPLine'] });
  };
};

export { MobilyOTPLineAction, numberSelected };